export { Panel } from './Panel'
export type {
  PanelBodyProps,
  PanelHeaderActionProps,
  PanelHeaderProps,
  PanelProps,
  PanelSectionProps,
} from './Panel.types'
